// extracted by mini-css-extract-plugin
module.exports = {"license":"a10a3f92e9--license--3w5nn","license-link":"a10a3f92e9--license-link--qUWEP"};